import { COLORS } from './common';

export default {
  label: 'Pandectes (GPC)',
  name: 'pandectes',
  component: 'group',
  description:
    'Settings pertaining to the GPC, specifically around Pandectes integration',
  fields: [
    {
      label: 'Enable Banner',
      name: 'gpcBannerEnabled',
      component: 'toggle',
      defaultValue: false,
    },
    {
      label: 'Display for gpc',
      name: 'gpcBannerGpcEnabled',
      component: 'toggle',
      defaultValue: false,
    },
    {
      label: 'Display for dnt',
      name: 'gpcBannerDntEnabled',
      component: 'toggle',
      defaultValue: false,
    },
    {
      label: 'Banner Text',
      name: 'gpcBannerText',
      component: 'text',
      defaultValue:
        'We respect your Global Privacy Control (GPC) signal and automatically opt you out of non-essential cookies and data sharing.',
    },
    {
      label: 'Banner Background Color',
      name: 'gpcBannerColor',
      component: 'select',
      options: COLORS,
      defaultValue: '#CCE0F1',
    },
  ],
};
